<template>
  <div>
    <!-- Tech Pack PDF -->
    <div v-if="viewDefaultTechpacks">
      <template v-if="app_environment === 'production'">
        <template v-if="order_item.order?.id > 115">
          <a
            target="_blank"
            :href="`order/${order_item.order?.id}/condensend-pdf`"
            class="btn btn-secondary mx-2 position-relative d-flex"
            :class="{ '': order_item.techpack_data_count === 0 }"
          >
            Tech Pack pdf
            <b-dropdown
              text=""
              :toggle-class="'mx-1 px-1 py-0'"
              v-if="order_item.techpack_data_count"
            >
              <b-dropdown-item
                :key="`order-item-version-${techpackDataVersion}`"
                target="_blank"
                :href="`order/${order_item.order?.id}/condensend-pdf?techpack_version=${techpackDataVersion}`"
                v-for="techpackDataVersion in order_item.techpack_data_count"
              >
                Version {{ techpackDataVersion }}
              </b-dropdown-item>
            </b-dropdown>
          </a>
        </template>
      </template>
      <template v-else>
        <a
          target="_blank"
          :href="`order/${order_item.order?.id}/condensend-pdf`"
          class="btn btn-secondary mx-2 position-relative d-flex"
          :class="{ '': order_item.techpack_data_count === 0 }"
        >
          Tech Pack pdf
          <b-dropdown
            text=""
            :toggle-class="'mx-1 px-1 py-0'"
            v-if="order_item.techpack_data_count"
          >
            <b-dropdown-item
              :key="`order-item-version-${techpackDataVersion}`"
              target="_blank"
              :href="`order/${order_item.order?.id}/condensend-pdf?techpack_version=${techpackDataVersion}`"
              v-for="techpackDataVersion in order_item.techpack_data_count"
            >
              Version {{ techpackDataVersion }}
            </b-dropdown-item>
          </b-dropdown>
        </a>
      </template>
    </div>
    <!-- Merchant PDF -->
    <div v-if="viewMerchatTechpacks">
      <template v-if="app_environment === 'production'">
        <template v-if="order_item.order && order_item.order.id > 115">
          <div v-if="merchant_techpack_urls.length > 1">
            <a
              class="btn btn-secondary d-flex"
              @click="openPdf(merchant_techpack_urls[0])"
              v-bind="
                merchant_techpack_urls[0]
                  ? {
                      href: `${storage_url}/${merchant_techpack_urls[0]}`,
                      target: '_blank',
                    }
                  : {}
              "
            >
              Techpack PDF
              <b-dropdown
                text=""
                :toggle-class="'mx-1 px-1 py-0'"
                v-if="merchant_techpack_urls.slice(1).length > 0"
              >
                <b-dropdown-item
                  v-for="(
                    techpackDataVersion, techpackIndex
                  ) in merchant_techpack_urls.slice(1)"
                  :key="`merchant-version-${techpackIndex}`"
                  @click="openPdf(techpackDataVersion)"
                  v-bind="
                    techpackDataVersion
                      ? {
                          href: `${storage_url}/${techpackDataVersion}`,
                          target: '_blank',
                        }
                      : {}
                  "
                >
                  Version {{ techpackIndex + 1 }}
                </b-dropdown-item>
              </b-dropdown>
            </a>
          </div>
          <a
            v-else
            class="btn btn-secondary"
            @click="openPdf(merchant_techpack_urls[0])"
            v-bind="
              merchant_techpack_urls[0]
                ? {
                    href: `${storage_url}/${merchant_techpack_urls[0]}`,
                    target: '_blank',
                  }
                : {}
            "
          >
            Techpack PDF
          </a>
        </template>
      </template>
      <template v-else>
        <div v-if="merchant_techpack_urls.length > 1">
          <a
            class="btn btn-secondary d-flex"
            v-bind="
              merchant_techpack_urls[0]
                ? {
                    href: `${storage_url}/${merchant_techpack_urls[0]}`,
                    target: '_blank',
                  }
                : {}
            "
            @click="openPdf(merchant_techpack_urls[0])"
          >
            Techpack PDF
            <b-dropdown
              text=""
              :toggle-class="'mx-1 px-1 py-0'"
              v-if="merchant_techpack_urls.slice(1).length > 0"
            >
              <b-dropdown-item
                v-for="(
                  techpackDataVersion, techpackIndex
                ) in merchant_techpack_urls.slice(1)"
                :key="`merchant-version-${techpackIndex}`"
                @click="openPdf(techpackDataVersion)"
                v-bind="
                  techpackDataVersion
                    ? {
                        href: `${storage_url}/${techpackDataVersion}`,
                        target: '_blank',
                      }
                    : {}
                "
              >
                Version {{ techpackIndex + 1 }}
              </b-dropdown-item>
            </b-dropdown>
          </a>
        </div>
        <a
          v-else
          class="btn btn-secondary"
          @click="openPdf(techpackDataVersion)"
          v-bind="
            merchant_techpack_urls[0]
              ? {
                  href: `${storage_url}/${merchant_techpack_urls[0]}`,
                  target: '_blank',
                }
              : {}
          "
        >
          Techpack PDF
        </a>
      </template>
    </div>
    <!-- Factory PDF -->
    <div v-if="viewFactoryTechpacks">
      <template v-if="app_environment === 'production'">
        <template v-if="order_item.order && order_item.order.id > 115">
          <a
            class="btn btn-secondary d-flex"
            @click="openPdf(factory_techpack_urls[0])"
            v-bind="
              factory_techpack_urls[0]
                ? {
                    href: `${storage_url}/${factory_techpack_urls[0]}`,
                    target: '_blank',
                  }
                : {}
            "
            v-if="factory_techpack_urls.length > 1"
          >
            Techpack PDF
            <b-dropdown
              text=""
              :toggle-class="'mx-1 px-1 py-0'"
              v-if="factory_techpack_urls.slice(1).length > 0"
            >
              <b-dropdown-item
                v-for="(
                  techpackDataVersion, techpackIndex
                ) in factory_techpack_urls.slice(1)"
                :key="`factory-version-${techpackIndex}`"
                @click.stop="openPdf(techpackDataVersion)"
                v-bind="
                  techpackDataVersion
                    ? {
                        href: `${storage_url}/${techpackDataVersion}`,
                        target: '_blank',
                      }
                    : {}
                "
              >
                Version {{ techpackIndex + 1 }}
              </b-dropdown-item>
            </b-dropdown>
          </a>
          <a
            v-else
            class="btn btn-secondary"
            @click="openPdf(factory_techpack_urls[0])"
            v-bind="
              factory_techpack_urls[0]
                ? {
                    href: `${storage_url}/${factory_techpack_urls[0]}`,
                    target: '_blank',
                  }
                : {}
            "
          >
            Techpack PDF
          </a>
        </template>
      </template>
      <template v-else>
        <div v-if="factory_techpack_urls.length > 1">
          <a
            class="btn btn-secondary d-flex"
            @click="openPdf(factory_techpack_urls[0])"
            v-bind="
              factory_techpack_urls[0]
                ? {
                    href: `${storage_url}/${factory_techpack_urls[0]}`,
                    target: '_blank',
                  }
                : {}
            "
          >
            Techpack PDF
            <b-dropdown
              text=""
              :toggle-class="'mx-1 px-1 py-0'"
              v-if="factory_techpack_urls.slice(1).length > 0"
            >
              <b-dropdown-item
                v-for="(
                  techpackDataVersion, techpackIndex
                ) in factory_techpack_urls.slice(1)"
                :key="`factory-version-${techpackIndex}`"
                @click.stop="openPdf(techpackDataVersion)"
                v-bind="
                  techpackDataVersion
                    ? {
                        href: `${storage_url}/${techpackDataVersion}`,
                        target: '_blank',
                      }
                    : {}
                "
              >
                Version {{ techpackIndex + 1 }}
              </b-dropdown-item>
            </b-dropdown>
          </a>
        </div>
        <a
          v-else
          class="btn btn-secondary"
          @click="openPdf(factory_techpack_urls[0])"
          v-bind="
            factory_techpack_urls[0]
              ? {
                  href: `${storage_url}/${factory_techpack_urls[0]}`,
                  target: '_blank',
                }
              : {}
          "
        >
          Techpack PDF
        </a>
      </template>
    </div>

    <template v-if="$can('update-techpack')">
      <router-link
        tag="a"
        :to="`edit-techpack/${order_item.order?.id}`"
        class="btn btn-secondary mx-2 position-relative"
      >
        Edit Tech Pack
      </router-link>
    </template>
  </div>
</template>

<script>
import { http } from "@/config/httpCommon";

export default {
  name: "TechPackButtons",

  props: {
    order_item: { type: Object, required: true },
    is_default: { type: Boolean, default: false },
  },

  data() {
    return {
      app_environment: process.env.NODE_ENV,
      storage_url: process.env.VUE_APP_FILE_URL,
    };
  },

  computed: {
    factory_techpack_urls() {
      return this.order_item.factory_techpack_pdf_urls || [];
    },
    merchant_techpack_urls() {
      return (
        (this.order_item.order &&
          this.order_item.order.merchant_techpack_pdf_urls) ||
        []
      );
    },
    viewDefaultTechpacks() {
      if (this.$can("view-merchant-pdf")) {
        return (
          this.merchant_techpack_urls.every((url) => url === null) ||
          this.merchant_techpack_urls.length === 0
        );
      } else if (this.$can("view-factory-pdf")) {
        return (
          this.factory_techpack_urls.every((url) => url === null) ||
          this.factory_techpack_urls.length === 0
        );
      }
      return false;
    },
    viewMerchatTechpacks() {
      if (this.$can("view-merchant-pdf")) {
        return (
          this.merchant_techpack_urls.length > 0 &&
          this.merchant_techpack_urls.some((url) => url !== null)
        );
      }
      return false;
    },

    viewFactoryTechpacks() {
      if (this.$can("view-factory-pdf")) {
        return (
          this.factory_techpack_urls.length > 0 &&
          this.factory_techpack_urls.some((url) => url !== null)
        );
      }
      return false;
    },
  },

  methods: {
    async fetchAndOpenPdf(order, version_id) {
      try {
        const order_id = order.id;
        const techpack_data_length = order.techpack_data
          ? order.techpack_data.length
          : 0;

        this.$store.commit("set", ["showLoader", true]);
        const response = await http.get(
          `techpackpdf/order/${order_id}/version/${version_id}`
        );
        this.$store.commit("set", ["showLoader", false]);

        const pdfUrl = response.data.result.pdf_url;
        if (pdfUrl) {
          window.open(`${this.storage_url}/${pdfUrl}`, "_blank");
        } else {
          if (techpack_data_length) {
            window.open(
              `order/${order_id}/condensend-pdf?techpack_version=${version_id}`,
              "_blank"
            );
          } else {
            window.open(`order/${order_id}/condensend-pdf`, "_blank");
          }
        }
      } catch (error) {
        console.error("Error fetching the PDF URL:", error);
      }
    },

    openPdf(url) {
      if (url === null) {
        this.showToast("File not ready yet. Please try again later", "info");
      }
    },
  },
};
</script>
<style scoped>
.btn.d-flex {
  width: max-content !important;
}
</style>
